import types from "./types";

export default {
  [types.FETCH_PRODUCT_SCHEDULE]: (state, payload) => {
    state.productSchedule = payload;
  },
  [types.UPDATE_COPY_SCHED]: (state, payload) => {
    state.copyScheduleData = payload;
  }
};
